import React from 'react';
import { motion } from 'framer-motion';
const painPoints = [{
  title: 'Cansancio sin razón',
  description: 'Te sientes agotado aunque hayas dormido bien. El azúcar alta roba tu energía celular.'
}, {
  title: 'Vista borrosa',
  description: 'La glucosa alta daña los vasos sanguíneos de tus ojos lentamente, sin que lo notes.'
}, {
  title: 'Heridas que no sanan',
  description: 'Cortadas pequeñas tardan semanas. El azúcar alta impide que tu cuerpo se repare.'
}, {
  title: 'Problemas circulatorios',
  description: 'Hormigueo en pies y manos. El azúcar está dañando tus nervios periféricos.'
}, {
  title: 'Problemas Renales',
  description: 'Tus riñones trabajan en exceso para filtrar la glucosa, dañando su capacidad de limpiar tu sangre con el tiempo.'
}, {
  title: 'Problemas Cardiovasculares',
  description: 'El exceso de azúcar endurece y estrecha tus arterias, multiplicando el riesgo de infartos silenciosos.'
}];
export function Problem() {
  return <section className="relative bg-ivory py-[40px] md:py-[64px] px-6" data-id="element-233">
      <div className="max-w-[860px] mx-auto" data-id="element-234">
        <div className="premium-card overflow-hidden" data-id="element-235">
          {/* Header Band */}
          <div className="bg-cream p-10 md:p-12 border-b border-border" data-id="element-236">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} className="flex flex-col items-center text-center" data-id="element-237">
              <p className="font-mono text-[11px] tracking-[0.15em] text-cocoa uppercase mb-6" data-id="element-238">
                EL PROBLEMA REAL
              </p>

              <h2 className="font-serif font-[900] text-[36px] md:text-[40px] leading-[1.15] text-text-primary mb-6 max-w-[620px]" data-id="element-239">
                Tu glucosa está dañando tu cuerpo. Y nadie te lo está diciendo
                claro.
              </h2>

              <p className="font-lora text-[18px] leading-[1.8] text-text-secondary max-w-[620px]" data-id="element-240">
                El azúcar alta destruye en silencio. Año tras año, daña tus
                nervios, riñones, ojos y corazón antes de que sientas síntomas.
                Y la información médica casi nunca se explica en español de una
                manera que respete tu inteligencia y tu tiempo.
              </p>
            </motion.div>
          </div>

          {/* Pain Points Grid */}
          <div className="p-10 md:p-12" data-id="element-241">
            <div className="grid md:grid-cols-2 gap-x-12 gap-y-8" data-id="element-242">
              {painPoints.map((point, index) => <motion.div key={index} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.6,
              delay: index * 0.1
            }} className="group flex items-start gap-4 p-4 -ml-4 rounded-lg hover:bg-cream transition-colors duration-150 ease-in-out" data-id="element-243">
                  <span className="text-cocoa font-bold text-xl mt-1" data-id="element-244">→</span>
                  <div data-id="element-245">
                    <h3 className="font-serif font-bold text-[20px] text-text-primary mb-2" data-id="element-246">
                      {point.title}
                    </h3>
                    <p className="font-lora text-[16px] leading-[1.7] text-text-secondary italic" data-id="element-247">
                      "{point.description}"
                    </p>
                  </div>
                </motion.div>)}
            </div>
          </div>
        </div>
      </div>

      {/* Section Separator */}
      <div className="absolute bottom-0 left-0 right-0 h-2 bg-gradient-to-b from-transparent to-[#FAF7F0]" data-id="element-248"></div>
    </section>;
}